<template>
    <div class="row" v-if="basket.booking_items.length > 0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="box-layout-inner">
                <div class="full-width border-bottom dark-blue" :class="{ 'dark-red': basket.booking_state_id == 5}">
                    <div class="booking-reference">
                        <div class="left">
                            <span class="title" v-if="$parent.isThankyou && basket.booking_state_id != 5">{{ $parent.locale.confirmation.text_thank_you }}</span>
                            <span class="title" v-else-if="$parent.isThankyou && basket.booking_state_id == 5">{{ $parent.locale.confirmation.text_thank_you_cancelled }}</span>

                            <!--<pre v-html="basket"></pre>-->
                            <span class="content" v-if="$parent.isThankyou && basket.booking_state_id == 5">{{ $parent.locale.confirmation.text_booking_cancelled }}</span>
                            <span class="content" v-else-if="$parent.isThankyou && basket.original_booking_item != null">{{ $parent.locale.confirmation.text_booking_edited }}</span>
                            <span class="content" v-else-if="$parent.isThankyou">{{ $parent.locale.confirmation.text_booking_successful }}</span>
                            <span class="content" v-else-if="basket.booking_state_description">{{ $parent.locale.text_booking_state_description_prefix }} {{basket.booking_state_description }}</span>
                        </div>

                        <div class="right">
                            <div class="booking-title">
                                <span v-if="basket.booking_state_id == 5">cancelled</span> booking reference
                            </div>

                            <div class="reference-number">
                                {{ booking_id }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="full-width light-blue share-container" v-if="$parent.isThankyou && basket.booking_state_id != 5">
                    <div class="share-box">
                        <div class="left">
                            <span class="title">
                                {{ $parent.locale.confirmation.text_social_header }}
                            </span>

                            <span class="content">
                                {{ $parent.locale.confirmation.text_social_description }}
                            </span>
                        </div>

                        <div class="right">
                            <a @click="share" class="fa fa-facebook" id="shareToFacebook"></a>
                            <a @click="tweet" class="fa fa-twitter" id="shareToTwitter"></a>
                        </div>
                    </div>
                </div>
                <div class="full-width dark-blue share-container" v-if="$parent.isThankyou">
                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                        <router-link :to="{ name: 'account.overview' }" class="cta-button blue">Go to my account</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['booking_id', 'basket'],
		data () {
            return {
                social_venue_name: '',
				social_venue_town: '',
				social_venue_slug: '',
				social_first_child_name:'',
				social_child_names: '',
				social_first_package_template_name: '',
            }
        },
        computed: {
            cancelled: function () {
                if(this.basket.booking_state_id == 5)
                    return true
                return false;
            }
        },
        methods: {
			dynamic_share_message: function (message) {
			
				var social_venue_name = this.basket.booking_items[0].items[0].venue_name;
				var social_venue_town = this.basket.booking_items[0].items[0].venue_town;
				var social_venue_slug = this.basket.booking_items[0].items[0].venue_slug;
				var social_first_child_name = this.basket.booking_items[0].items[0].participant_full_name.split(" ")[0];
				var social_child_names = this.basket.booking_items[0].items[0].participant_full_name.split(" ")[0];
				var social_first_package_template_name = this.basket.booking_items[0].items[0].package_name;

				//If we have more than 1 booking item
				if (Object.keys(this.basket.booking_items).length > 1) {
					
					//Add to array
					var social_child_names_array = [];
					
					this.basket.booking_items.forEach(function (booking_item) {
						booking_item.items.forEach(function (item) {
							social_child_names_array.push(item.participant_full_name.split(" ")[0]);
						});
					});
					
					//Remove duplicates
					social_child_names_array = social_child_names_array.filter(function(elem, index, self) {
						return index == self.indexOf(elem);
					})
					
					//Get a comma separated string with the last element as "and"
					social_child_names = social_child_names_array.join(', ').replace(/,(?!.*,)/gmi, ' and');

				}

				var placeholders = { "child_names": social_child_names, 
									"venue_name": social_venue_name, 
									"venue_town": social_venue_town, 
									"venue_slug": social_venue_slug, 
									"first_child_name": social_first_child_name, 
									"first_child_month_next_attending": "6", 
									"first_child_package_template_name": social_first_package_template_name, 
									}
				var messageTemplate = message;
				var dynamicMessage = messageTemplate.replace('%CHILD-NAMES%', placeholders.child_names)
												 .replace('%VENUE-NAME%', placeholders.venue_name)
												 .replace('%VENUE-TOWN%', placeholders.venue_town)
												 .replace('%VENUE-SLUG%', placeholders.venue_slug)
												 .replace('%FIRST-CHILD-NAME%', placeholders.first_child_name)
												 .replace('%FIRST-CHILD-MONTH-NEXT-ATTENDING%', placeholders.first_child_month_next_attending)
												 .replace('%FIRST-CHILD-PACKAGE-TEMPLATE-NAME%', placeholders.first_child_package_template_name);
				
				return dynamicMessage;
			},
            share: function () {
			
				//Get social media share info
				if (this.basket.booking_items.length > 0 && this.basket.booking_state_id !== 5 && typeof this.$parent.locale.confirmation.text_facebook_share_quote !== 'undefined') {
	
					var facebookShareMessage = this.dynamic_share_message(this.$parent.locale.confirmation.text_facebook_share_quote);
				
				} else {
				
					//Use fallback 
					var facebookShareMessage =this.$parent.locale.confirmation.text_facebook_share_quote_fallback;
				}	
											window.open(encodeURI("https://www.facebook.com/dialog/share?app_id="+this.$parent.locale.confirmation.facebook_app_id+"&quote="+facebookShareMessage+"&display=popup&href="+this.$parent.locale.confirmation.text_facebook_share_url), "pop", "width=600, height=400, scrollbars=no");
					return false;
					
            },
            tweet: function () {
				
				//Get social media share info
				if (this.basket.booking_items.length > 0 && this.basket.booking_state_id !== 5 && typeof this.$parent.locale.confirmation.text_twitter_tweet !== 'undefined') {
	
					var twitterShareMessage = this.dynamic_share_message(this.$parent.locale.confirmation.text_twitter_tweet);
				
				} else {
				
					//Use fallback 
					var twitterShareMessage =this.$parent.locale.confirmation.text_facebook_share_quote_fallback;
				}	
				
                window.open(encodeURI("https://twitter.com/intent/tweet?text="+twitterShareMessage), "pop", "width=600, height=400, scrollbars=no");
                return false;
				
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PaymentConfirmation.vue?27d544fe